import axios from "axios";
import store from "@/store";

const utils = {
  // 登录判断与用户信息初始化
  // 仅用于路由判断
  checkLogin() {
    axios
      .post("/match/checktUserInfo")
      .then((res) => {
        if (res.data.code == 200) {
          // this.initUserInfo(res);
          // console.log(res.data.data)
          store.commit("changeLogin", true);
          store.commit("changeUserInfo", res.data.data);
          // console.log(store.state.isLogin);
          // document.getElementById('triggerCommonLogin').click();
        } else {
          /* eslint-disable */
          // 调用passport
          passportLogin.login();
          /* eslint-enable */
        }
      })
      /* eslint-disable */
      .catch((err) => {
        // 调用passport
        passportLogin.login();
      });
    /* eslint-enable */
  },
  isLogin() {
    if (!store.state.isLogin) {
      /* eslint-disable */
      // 调用passport
      passportLogin.login();
      /* eslint-enable */
      return false;
    }
  },
  // 初始化用户信息
  initUserInfo(userinfo) {
    // 如果已登录，header 载入已登录信息
    // 否则 next()
    console.log(userinfo);
  },
  // 分享组件
  // shareTo(stype) {
  //   var ftit = "";
  //   var flink = "";
  //   var lk = "";
  //   //获取文章标题
  //   ftit = document.title;
  //   //获取网页中内容的第一张图片地址作为分享图
  //   flink = document.images[0].src;
  //   if (typeof flink == "undefined") {
  //     flink = "";
  //   }
  //   //当内容中没有图片时，设置分享图片为网站logo
  //   if (flink == "") {
  //     lk = "http://" + window.location.host + "/images/logo.png";
  //   }
  //   //如果是上传的图片则进行绝对路径拼接
  //   if (flink.indexOf("/uploads/") != -1) {
  //     lk = "http://" + window.location.host + flink;
  //   }
  //   //百度编辑器自带图片获取
  //   if (flink.indexOf("ueditor") != -1) {
  //     lk = flink;
  //   }
  //   //qq空间接口的传参
  //   if (stype == "qzone") {
  //     window.open(
  //       "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
  //         document.location.href +
  //         "?sharesource=qzone&title=" +
  //         ftit +
  //         "&pics=" +
  //         lk +
  //         "&summary=" +
  //         document
  //           .querySelector('meta[name="description"]')
  //           .getAttribute("content")
  //     );
  //   }
  //   //新浪微博接口的传参
  //   if (stype == "weibo") {
  //     console.log(document.location.href, ftit, lk);
  //     window.open(
  //       "http://service.weibo.com/share/share.php?url=" +
  //         document.location.href +
  //         "?sharesource=weibo&title=" +
  //         ftit +
  //         "&pic=" +
  //         lk +
  //         "&appkey=2706825840"
  //     );
  //   }
  //   //qq好友接口的传参
  //   if (stype == "qq") {
  //     window.open(
  //       "http://connect.qq.com/widget/shareqq/index.html?url=" +
  //         document.location.href +
  //         "?sharesource=qzone&title=" +
  //         ftit +
  //         "&pics=" +
  //         lk +
  //         "&summary=" +
  //         document
  //           .querySelector('meta[name="description"]')
  //           .getAttribute("content") +
  //         "&desc=千途导摄，一个优秀摄影师聚集的网站"
  //     );
  //   }
  //生成二维码给微信扫描分享，php生成，也可以用jquery.qrcode.js插件实现二维码生成
  // if (stype == "wechat") {
  //   window.open(
  //     "http://zixuephp.net/inc/qrcode_img.php?url=http://zixuephp.net/article-1.html"
  //   );
  // }
  // },
};

// module.exports = utils;
export default utils;
